<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/employee-cards', text: 'employeeCard_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'employeeCard_listTitle' | translate}}</h1>
        <aside>
            <button *ngIf="canEdit" type="button" class="btn btn-outline-primary"
                    [disabled]="hasActive"
                    [ngbTooltip]="hasActive ? ('employeeCard_activeAlreadyExists' | translate) : ''"
                    [routerLink]="['/employee-cards/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <form *ngIf="canAdmin">
        <div class="row">
            <div class="col-md form-field">
                <app-select name="filterStatus"
                            [placeholder]="'employeeCard_lblStatus' | translate"
                            [options]="filters.status.options"
                            [multiple]="true"
                            [valueProperty]="'value'"
                            [displayProperty]="'text'"
                            [(ngModel)]="filters.status.value"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="col-md form-field">
                <app-select name="filterReason"
                            [placeholder]="'employeeCard_lblRevocationReason' | translate"
                            [options]="filters.reason.options"
                            [multiple]="true"
                            [valueProperty]="'value'"
                            [displayProperty]="'text'"
                            [(ngModel)]="filters.reason.value"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="col-md form-field">
                <input class="form-control"
                        name="filterSearch"
                        [placeholder]="'employeeCard_lblSearch' | translate"
                        [(ngModel)]="filters.search"
                        (input)="filter()">
            </div>
        </div>
    </form>

    <app-table [rows]="items" [columns]="columns" [auto]="false" (sortChange)="sort($event)">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>
                    <div class="text-top">{{row.Name}} {{row.Surname}}</div>
                    <div class="text-sub">{{row.Upn}}</div>
                    <div class="hidden-md-up mt-1">{{row.Structure}}</div>
                    <div class="hidden-md-up"><em>{{row.Position}}</em></div>
                    <div class="hidden-md-up mt-1">
                        <app-employee-card-status [value]="row.Status" [description]="row.CancellationReason"></app-employee-card-status>
                    </div>
                    <div class="hidden-md-up mt-1">{{row.Modified | appDate:'datetime'}}</div>
                </td>
                <td class="hidden-sm-down">
                    <div>{{row.Structure}}</div>
                    <div class="text-sub">{{row.Position}}</div>
                </td>
                <td class="hidden-md-down">{{row.Position}}</td>
                <td class="hidden-sm-down">
                    <app-employee-card-status [value]="row.Status" [description]="row.CancellationReason"></app-employee-card-status>
                    <div class="hidden-md-up mt-1">{{row.Modified | appDate:'datetime'}}</div>
                </td>
                <td class="hidden-sm-down">{{row.Modified | appDate:'datetime'}}</td>
                <td>
                    <div class="table-actions">
                        <button *ngIf="canAdmin"
                                type="button"
                                (click)="download(row)"
                                class="btn btn-outline btn-icon"
                                [ngbTooltip]="'download' | translate">
                            <i class="fi fi-rs-download"></i>
                        </button>

                        <button type="button"
                                class="btn btn-outline btn-icon"
                                [routerLink]="['/employee-cards', row.Id] | localize"
                                [ngbTooltip]="'open' | translate">
                            <i class="fi fi-rs-angle-right"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>
